<mat-nav-list>
  <h3 matSubheader>Contrato: {{codContrato}}<br>Parcelas para Renegociação</h3>

  <mat-divider></mat-divider>

  <div *ngIf="!isMobile" class="desktop-size">
    <mat-list-item>
      <div
        fxLayout="row"
        fxLayout.xs="row"
        fxFlexFill
        fxLayoutAlign="left"
      >
        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine>Parcelas</span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine>Vencimento</span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine>Valor</span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine>Status</span>
        </div>


        <div
          fxFlex="20%"
          fxLayoutAlign="center center"
        >
        </div>
      </div>
    </mat-list-item>

    <mat-divider></mat-divider>

    <mat-list-item *ngFor="let parcela of parcelas">
      <div
        fxLayout="row"
        fxLayout.xs="row"
        fxFlexFill
        fxLayoutAlign="left"
      >
        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine> {{parcela.numeroParcela}}/{{qtdeParcelasTotal}} </span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine> {{convertToDatabaseDate(parcela.dataVencimento) | date }} </span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine> {{parcela.valorTotalParcela | currency:'BRL':true:'1.2-2' }} </span>
        </div>

        <div
          fxFlex="20%"
          class="contract-list"
        >
          <span matLine> {{parcela.statusParcela}} </span>
        </div>

        <div
          fxFlex="20%"
          fxLayoutAlign="center center"
        >
          <button
            *ngIf="permitirGerarSegundaVia(parcela.statusParcela)"
            mat-raised-button
            color="primary"
            (click)="selecionarParcela(parcela)"
          >Gerar 2ª via </button>

        </div>

      </div>

    </mat-list-item>

  </div>

  <div *ngIf="isMobile && rendering" class="mobile-size">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let parcela of parcelas">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Parcela {{parcela.numeroParcela}}/{{qtdeParcelasTotal}}
          </mat-panel-title>
          <mat-panel-description>
            <span>Status:&nbsp;</span>
            <span [class]="parcela.statusParcela">{{parcela.statusParcela}}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="content">

          <p>Data de Vencimento: {{convertToDatabaseDate(parcela.dataVencimento) | date:'dd/MM/yyyy' }}</p>
          <p>Valor: {{parcela.valorTotalParcela | currency:'BRL':true:'1.2-2' }}</p>

          <div class="expasion-button">
            <button
              *ngIf="permitirGerarSegundaVia(parcela.statusParcela)"
              mat-raised-button
              color="primary"
              (click)="selecionarParcela(parcela)"
            >Gerar 2ª via </button>
          </div>

        </div>

      </mat-expansion-panel>

    </mat-accordion>
  </div>

</mat-nav-list>